import React, { PropsWithChildren } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import * as ErrorFallback from 'components/ErrorFallback';
import { FallbackProps } from 'components/ErrorFallback/types';

const useStyles = makeStyles({
  container: {
    height: '213px',
  },
});

function Fallback({ resetError, eventId }: FallbackProps) {
  const styles = useStyles();
  const { t } = useTranslation('Sentry');

  return (
    <ErrorFallback.Container className={styles.container}>
      <ErrorFallback.Title title={t('genericErrorBoundary.title2')} />
      <ErrorFallback.Actions resetError={resetError} eventId={eventId} />
    </ErrorFallback.Container>
  );
}

function ErrorBoundary({ children }: PropsWithChildren<{}>) {
  return (
    <SentryErrorBoundary
      beforeCapture={scope => {
        scope.setTag('component', 'customer info');
      }}
      fallback={({ resetError, eventId }) => (
        <Fallback resetError={resetError} eventId={eventId} />
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
}

export default ErrorBoundary;
